/* Dansk katalog for locale-autopilot-followup.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'ap.skip.title': 'Spring opfølgning over',
  'ap.skip.nextMonth': 'Mind mig om det næste måned',
  'ap.skip.always': 'Ignorér dette punkt',
  'ap.skip.help': 'Udskyd punktet til næste måned, eller ignorér netop dette punkt. Nye fakturaer, kunder og andre nye fund vises stadig.',
  'ap.skip.itemFallback': 'Dette opfølgningspunkt',
  'ap.skip.all': 'Spring alle over',
  'ap.skip.allInvoices': 'Alle dokumenter på denne liste',
  'ap.skip.allCustomers': 'Alle kunder på denne liste',
  'ap.agent.followup.title': 'Opfølgningsagenten',
  'ap.agent.followup.detail': 'Fanger oplysninger og afvigelser, der ikke hører til en indberetningsagent.',
  'ap.permission.followup.label': 'Opfølgningsagenten',
  'ap.permission.followup.desc': 'Fanger oplysninger, kundedialoger og afvigelser, der ikke hører til en indberetningsagent.',
  'ap.lineIgnoredToast': 'Dette punkt er ignoreret. Nye opfølgningspunkter vises stadig.',
  'ap.linesSkippedToast': '{{count}} punkter er sprunget over.',
  'ap.followup.correctionOne': '{{count}} fejl skal rettes.',
  'ap.followup.correctionMany': '{{count}} fejl skal rettes.',
  'ap.followup.correctionDetailOne': '{{count}} punkt skal rettes',
  'ap.followup.correctionDetailMany': '{{count}} punkter skal rettes',
  'ap.followup.mustCorrect': 'Skal rettes',
  'ap.followup.correct': 'Ret',
  'ap.followup.correctInSettings': 'Ret i indstillinger',
});
